import { gql } from '@apollo/client';

export const ParagraphActivityPoiActivitiesInRegionFragment = gql`
  fragment ParagraphActivityPoiActivitiesInRegion on ParagraphActivityPoiActivitiesInRegion {
    id
    title
  }
`;
